import { defineComponent as _defineComponent } from 'vue'
import { type TextAlign } from '../../../types';
import { AbTitle, AbLink, AbDescription } from '../../ui';
import { useCdnImg } from '@webplatform/cdn-image';

interface Props {
  image?: string;
  alt?: string;
  name?: string;
  text?: string;
  link?: string;
  contentAlign?: TextAlign;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAppsItem',
  props: {
    image: null,
    alt: null,
    name: null,
    text: null,
    link: null,
    contentAlign: null
  },
  setup(__props: any) {



const { generateUrl } = useCdnImg();

return { __sfc: true,generateUrl, AbTitle, AbLink, AbDescription }
}

})